import React from 'react'
import * as R from 'remeda'

import { exists, getByPath, type Group } from '~/utils'

import { useAtomValueContext } from '../providers/AtomsProvider'

export const useTabulatedGroups = () => {
  const questionQueryData = useAtomValueContext('questionQueryData')
  const customerAttributeQueryData = useAtomValueContext(
    'customerAttributeQueryData',
  )

  return React.useMemo<Group[]>(() => {
    const groupsFromQuestionQueryData = getByPath(
      questionQueryData,
      'results.0.0.groupAnswers',
    )?.map(R.prop('group'))
    if (exists(groupsFromQuestionQueryData)) {
      return groupsFromQuestionQueryData as Group[]
    }

    const groupsFromCustomerAttributeQueryData = getByPath(
      customerAttributeQueryData,
      '0.result.groupResults',
    )?.map(R.prop('group'))
    if (exists(groupsFromCustomerAttributeQueryData)) {
      return groupsFromCustomerAttributeQueryData as Group[]
    }

    return []
  }, [customerAttributeQueryData, questionQueryData])
}
